import Vue from "vue";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

if (!window.wbconfig?.debug) {
  Sentry.init({
    Vue,
    dsn: "https://4bbd43c5c5f2451f8b16de1ee5608989@o413606.ingest.sentry.io/5300485",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.001,
    logErrors: true,
  });
}

import App from "./App.vue";
// import "./registerServiceWorker";
import { router } from "./router";
import { makeStore } from "./store";

import Mousetrap from "mousetrap";
import ToolType from "./wbcontroller/types/ToolType";
import { RenderConfig } from "./store/modules/toolConfig";

// Global backspace listener is used to disable the back naviagation
// The user probably press backsapce to try to delete a shape
Mousetrap.bind("backspace", () => {
  return false;
});

Vue.config.productionTip = false;
Vue.config.devtools = true;

interface HashArgs {
  colors?: string[];
  strokeWidths?: number[];
  defaultLineCap?: "square" | "butt" | "round";
  tools?: ToolType[];
  isZoomAllowed?: boolean;
  renderConfig?: RenderConfig;
}
function parseHash(hash: string): HashArgs {
  const result: HashArgs = {
    colors: undefined,
    strokeWidths: undefined,
    defaultLineCap: undefined,
    tools: undefined,
    isZoomAllowed: undefined,
    renderConfig: undefined,
  };

  const params = new URLSearchParams(hash);
  result.colors = params.get("colors")?.split(",");

  const maybeStrokeWidths = params
    .get("strokeWidths")
    ?.split(",")
    .map((w) => parseFloat(w));
  if (maybeStrokeWidths) {
    result.strokeWidths = maybeStrokeWidths;
  }

  const maybeDefaultLineCap = params.get("defaultLineCap");
  if (maybeDefaultLineCap) {
    result.renderConfig = {
      defaultLineCap: maybeDefaultLineCap as "round" | "butt" | "square",
    };
  }

  const maybeIsZoomAllowed = params.get("isZoomAllowed");
  if (maybeIsZoomAllowed) {
    result.isZoomAllowed = maybeIsZoomAllowed.toLowerCase() !== "false";
  }

  const maybeTools = params.get("tools")?.split(",");
  if (maybeTools) {
    result.tools = maybeTools as ToolType[];
  }

  return result;
}

const hashArgs: HashArgs | undefined = location.hash.length
  ? parseHash(location.hash.slice(1))
  : undefined;
const store = makeStore(
  window.wbconfig,
  hashArgs?.colors,
  hashArgs?.strokeWidths,
  hashArgs?.tools,
  hashArgs?.isZoomAllowed,
  hashArgs?.renderConfig
);

const initialKey = window.wbconfig.key?.id;
if (initialKey && store.state.user.isAnonymous) {
  window.history.replaceState(null, document.title, `?key=${initialKey}`);
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
